/* Omelva · ficha de la braguita · 2 de 3: añadir al carrito y continuar al pago.
   - El pack se añade con /cart/add.js y NO se redirige hasta comprobar en la respuesta de Shopify la variante,
     el precio y las tallas/colores de cada prenda.
   - «Continuar al pago»: si ese mismo pack (misma variante y mismas propiedades) ya está en el carrito no se
     vuelve a añadir, así un doble toque, un reintento o volver atrás desde el pago no duplican el pedido.
   - Nunca se vacía el carrito. Si ya había otros productos, se abre el cajón con el total en vez de saltar
     al pago a ciegas. */
(function () {
  var O = window.OMPF;
  if (!O || !O.form) return;
  var t = O.t;

  function json(url, opciones) {
    return fetch(url, opciones).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        if (!r.ok) { var e = new Error(d.description || d.message || ('HTTP ' + r.status)); e.status = r.status; e.datos = d; throw e; }
        return d;
      });
    });
  }
  function leerCarrito() { return json('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }); }

  function mismasPropiedades(a, b) {
    var ka = Object.keys(a || {}).filter(function (k) { return k.charAt(0) !== '_'; });
    var kb = Object.keys(b || {}).filter(function (k) { return k.charAt(0) !== '_'; });
    if (ka.length !== kb.length) return false;
    return ka.every(function (k) { return String(a[k]) === String(b[k]); });
  }
  function lineaIgual(carrito, id, props) {
    return (carrito.items || []).filter(function (l) {
      return String(l.variant_id) === String(id) && mismasPropiedades(l.properties, props);
    })[0] || null;
  }
  function fallo(tipo) { var e = new Error(tipo); e.tipo = tipo; return e; }

  /* Añade el pack configurado y comprueba lo que Shopify ha guardado de verdad. */
  function anadirPack(evitarDuplicado) {
    var r = O.packElegido();
    var id = r.value, centimos = parseInt(r.getAttribute('data-cents'), 10), props = O.propiedades();
    return leerCarrito().then(function (c) {
      var ya = lineaIgual(c, id, props);
      if (ya && evitarDuplicado) return { linea: ya, carrito: c };
      var q0 = ya ? ya.quantity : 0;
      return json('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1, properties: props }] })
      }).catch(function (err) {
        /* Si la respuesta se perdió pero Shopify sí lo añadió, se da por bueno en vez de reintentar a ciegas. */
        if (err.status) throw err;
        return leerCarrito().then(function (c2) {
          var l2 = lineaIgual(c2, id, props);
          if (l2 && l2.quantity > q0) return { items: [l2] };
          throw err;
        });
      }).then(function (resp) {
        var l = (resp.items || [])[0];
        if (!l || String(l.variant_id) !== String(id) || !mismasPropiedades(l.properties, props)) throw fallo('verificacion');
        if (parseInt(l.price, 10) !== centimos) throw fallo('precio');
        return leerCarrito().then(function (c3) {
          var final = lineaIgual(c3, id, props);
          if (!final) throw fallo('verificacion');
          return { linea: final, carrito: c3, anadido: true };
        });
      });
    }).then(function (res) {
      /* Si hay otras líneas, o ese pack ya estaba más de una vez, se enseña el cajón con el total antes de pagar. */
      res.otros = res.linea.quantity > 1 || (res.carrito.items || []).some(function (l) { return l.key !== res.linea.key; });
      return res;
    });
  }

  function abrirCajon(mensaje) {
    if (window.omCajon && window.omCajon.refrescar) {
      return window.omCajon.refrescar().then(function () {
        if (mensaje && window.omCajon.aviso) window.omCajon.aviso(mensaje);
        window.omCajon.abrir();
      });
    }
    window.location.href = '/cart';
    return Promise.resolve();
  }

  function bloquear(boton, texto) {
    O.ocupado = true;
    [O.btnPagar, O.btnAdd].forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    if (boton === O.btnPagar) boton.querySelector('[data-ompf-pagar-txt]').textContent = texto;
    else boton.textContent = texto;
  }
  function soltar() {
    O.ocupado = false;
    [O.btnPagar, O.btnAdd].forEach(function (b) { b.removeAttribute('aria-busy'); });
    O.pintarBotones();
  }
  function error(err) {
    var a = O.aviso;
    a.setAttribute('data-error', '1');
    if (err && err.tipo === 'precio') a.textContent = t('errorPrecio');
    else if (err && err.tipo === 'verificacion') a.textContent = t('errorRevisar');
    else if (err && err.status && err.datos && err.datos.description) a.textContent = err.datos.description;
    else a.textContent = t('errorRed');
  }

  function pagar() {
    if (O.ocupado) return;
    if (!O.ensenarFaltas()) return;
    bloquear(O.btnPagar, t('preparando', 'Preparando el pago…'));
    anadirPack(true).then(function (res) {
      if (res.otros) {
        soltar();
        return abrirCajon(t('otrosEnCarrito'));
      }
      /* Si se acaba de añadir, se da un segundo a los píxeles (Shopify, Meta, GA4) para que el evento de
         «añadido al carrito» salga antes de cambiar de página; si ya estaba en el carrito, se va directo. */
      setTimeout(function () { window.location.assign('/checkout'); }, res.anadido ? 1000 : 0);
    }).catch(function (err) {
      soltar();
      error(err);
      if (err && err.tipo === 'precio') abrirCajon(t('errorPrecio'));
      else if (err && err.tipo === 'verificacion') abrirCajon(t('errorRevisar'));
    });
  }

  function anadir() {
    if (O.ocupado) return;
    if (!O.ensenarFaltas()) return;
    bloquear(O.btnAdd, t('anadiendo', 'Añadiendo…'));
    anadirPack(false).then(function () {
      soltar();
      return abrirCajon('');
    }).catch(function (err) { soltar(); error(err); });
  }

  O.pagar = pagar;

  /* «Añadir al carrito» lo gestiona la ficha (con verificación): se para aquí para que el cajón no lo añada otra vez. */
  O.form.addEventListener('submit', function (e) {
    e.preventDefault();
    e.stopPropagation();
    anadir();
  });
  O.btnPagar.addEventListener('click', function (e) { e.preventDefault(); pagar(); });

  window.addEventListener('pageshow', function (ev) { if (ev.persisted) { soltar(); O.arranque(); } });
})();